import { Avatar, Box, Grid, Stack, Typography } from '@mui/material';
import { IEquipmentSingleOrder } from 'API';
import { ListDivider } from 'Components';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { PurpleOutlineWarningIcon, Warning } from 'Images';

interface IOrderItemProps {
  item: IEquipmentSingleOrder;
}

export const EquipmentItem = ({ item }: IOrderItemProps) => {
  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(Dictionary, DICTIONARY.Equipment);

  return isDesktop ? (
    <Box role='listitem' tabIndex={0}>
      <Grid container alignContent={'center'} sx={{ minHeight: '72px' }}>
        <Grid container item xs={6} md={5} alignContent={'center'}>
          <Typography variant='body6'>{item.itemName}</Typography>
        </Grid>
        <Grid container item xs={6} md={7}>
          <Grid
            container
            item
            justifyContent={'center'}
            sx={{
              maxWidth: '80px',
              maxHeight: '60px',
              backgroundColor: 'purple2.shade_100',
              padding: '18px 24px',
              margin: '10px',
            }}
          >
            <Typography>{item.quantity}</Typography>
          </Grid>

          <Grid
            container
            item
            xs={6}
            md={7}
            alignContent={'center'}
            p={'0 24px'}
          >
            {item.itemNote && (
              <Typography
                width='100%'
                variant='body6'
                sx={{ display: 'flex', wordBreak: 'break-word' }}
              >
                <Avatar
                  src={PurpleOutlineWarningIcon}
                  alt=''
                  sx={{
                    width: '24px',
                    height: '24px',
                    alignSelf: 'start',
                    mr: '6px',
                    display: 'inline-flex',
                  }}
                />
                {item.itemNote}
              </Typography>
            )}
            {item.quantityNote && (
              <Typography
                width='100%'
                variant='body6'
                sx={{ display: 'flex', wordBreak: 'break-word' }}
              >
                <Avatar
                  src={PurpleOutlineWarningIcon}
                  alt=''
                  sx={{
                    width: '24px',
                    height: '24px',
                    alignSelf: 'start',
                    mr: '6px',
                    display: 'inline-flex',
                  }}
                />
                {item.quantityNote}
              </Typography>
            )}
          </Grid>
        </Grid>
      </Grid>
      <ListDivider />
    </Box>
  ) : (
    <>
      {item.itemNote || item.quantityNote ? (
        <Grid
          container
          justifyContent={'space-between'}
          sx={{
            padding: 0,
            mt: 2,
            minHeight: '72px',
            borderRadius: '16px',
            border: '1px solid',
            borderColor: 'primary.shade_200',
          }}
        >
          <Grid
            container
            justifyContent={'space-between'}
            sx={{
              borderRadius: '16px 16px 0 0',
              width: '100%',
              padding: '16px 24px',
            }}
          >
            <Grid container item xs={7} alignItems={'center'}>
              <Typography variant='body6'>{item.itemName}</Typography>
            </Grid>
            <Grid
              container
              item
              justifyContent={'center'}
              alignContent={'center'}
              xs={5}
              sx={{
                maxWidth: '56px',
                maxHeight: '40px',
                backgroundColor: 'purple2.shade_100',
                padding: 1,
              }}
            >
              <Typography variant='body5'>{item.quantity}</Typography>
            </Grid>
          </Grid>

          {(item.itemNote || item.quantityNote) && (
            <Grid sx={{ padding: '10px 24px 16px 24px' }}>
              {item.itemNote && (
                <Stack>
                  <Typography variant='body6'>
                    {dictionary.orderSummaryDialog.itemNote}
                  </Typography>
                  <Typography variant='body6'>{item.itemNote}</Typography>
                </Stack>
              )}

              {item.quantityNote && (
                <Stack>
                  <Typography variant='body6' mt={item.itemNote ? 2 : 0}>
                    {dictionary.orderSummaryDialog.quantityNote}
                  </Typography>
                  <Typography variant='body6'>{item.quantityNote}</Typography>
                </Stack>
              )}
            </Grid>
          )}
        </Grid>
      ) : (
        <Grid
          container
          justifyContent={'space-between'}
          sx={{
            padding: 0,
            mt: 2,
            minHeight: '72px',
            borderRadius: '16px',
            border: '1px solid',
            borderColor: 'primary.shade_200',
          }}
        >
          <Grid
            container
            justifyContent={'space-between'}
            sx={{
              borderRadius: '16px 16px 0 0',
              width: '100%',
              padding: '16px 24px',
            }}
          >
            <Grid container item xs={7} alignItems={'center'}>
              <Typography variant='body6'>{item.itemName}</Typography>
            </Grid>
            <Grid
              container
              item
              justifyContent={'center'}
              alignContent={'center'}
              xs={5}
              sx={{
                maxWidth: '56px',
                maxHeight: '40px',
                backgroundColor: 'purple2.shade_100',
                padding: 1,
              }}
            >
              <Typography variant='body5'>{item.quantity}</Typography>
            </Grid>
          </Grid>
        </Grid>
      )}
    </>
  );
};
